import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class SidebarSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'sidebar');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [
            this.fontColorComboField('font.color', ['main', 'content', 'header']),
            this.backgroundColorField('background.color', ['main', 'content' ]),
            this.borderColorField('border.color', ['main', 'content']),
            this.dropShadowField('shadow'),
        ];
    }

}
